const template = `
<div class="horse-info-outer-container">
	<div class="horse-info-container">

		<div class="horse-info-top">
			<div class="horse-info-top-bar">
				<div class="stripes"></div>
				<button type="button" class="close"></button>
			</div>
			<ul class="horse-navigation">
				<li data-sticky-template="horse-info-navigation-item" data-id="%id%"><span>%startnumber%</span></li>
			</ul>
		</div>

		<div class="horse-info-loader loader loader--visible loader--with-light-bg loader--cover">
			<div class="loader__inner">
				<div class="spinner"></div>
				<h1>&nbsp;</h1>
			</div>
		</div>

		<div class="scroll-container">
			<div class="content-container">
				<div class="race-details" data-id="%id%" data-sticky-template="race-details">
					<div class="race-details-header">%race-details-header%</div>
					<p class="race-details-body">%race-details-body%</p>
				</div>

				<div class="horse-info-page" data-sticky-template="horse-info-page" data-id="%id%">

					<div class="horse-info-header">
						<div class="horse-details">
							<span><div class="start-number"></div></span>
							<span class="name"></span>
							<span class="jockey"></span>
							<span class="distance-post"></span>
							<span>
								<div class="cv-container">
									<a class="button cv">
										CV<span class="sprite button-external"></span>
									</a>
								</div>
							</span>
							<span>
								<div class="archive-container">
									<a class="button archive">
										<span class="sprite button-play"></span>
									</a>
								</div>
							</span>
							<span class="edit-button">
								<a class="sprite button-edit-white"></a>
							</span>
						</div>

					</div>

					<div class="horse-comment-container">
						<div class="horse-comment">
							<div class="horse-comment-text"></div>
							<div class="horse-comment-date"></div>
						</div>
						<a class="edit-horse-comment-button sprite button-edit"></a>
					</div>

					<div class="preliminary-equipment" >
						<div data-sticky-template="preliminary-equipment-row" class="preliminary-equipment-row" >
							<div class="preliminary-equipment-type"></div>
							<div class="preliminary-equipment-info">
								<div class="preliminary-equipment-info-actual" ><span class="bold" ></span><span class="bold"></span><span></span></div>
								<div class="preliminary-equipment-info-statistics" ></div>
							</div>
						</div>
					</div>

					<table class="race-history">
						<thead>
							<tr>
								<th></th>
								<th></th>
								<th>%history-th-jockey%</th>
								<th>%history-th-track%</th>
								<th>%history-th-date-run%</th>
								<th>%history-th-line-distance%</th>
								<th>%history-th-result%</th>
								<th>%history-th-time%</th>
								<th>%history-th-horseshoes%</th>
								<th>%history-th-wagon%</th>
								<th>%history-th-odds%</th>
								<th>%history-th-price%</th>
								<th>%history-th-track-conditions%</th>
							</tr>
						</thead>
						<tbody>
							<tr data-sticky-template="horse-info-page-previous-result-row">
								<td class="info-1"></td>
								<td class="info-2"></td>
								<td class="jockey"></td>
								<td class="track"></td>
								<td class="date-race"></td>
								<td class="post-distance"></td>
								<td class="place"></td>
								<td class="time"></td>
								<td class="shoes"></td>
								<td class="wagon"></td>
								<td class="odds"></td>
								<td class="first-prize"></td>
								<td class="track-state"></td>
							</tr>
						</tbody>

					</table>

					<table class="race-comments">
						<thead>
							<tr><th colspan="6">%race-comments-title%</th></tr>
						</thead>
						<tbody>
							<tr class="comment-row1" data-sticky-template="horse-info-race-comments-row-1">
								<td class="track-code"></td>
								<td class="date-race-number"></td>
								<td class="intermediate-times"></td>
								<td class="top-horses" data-sticky-template="horse-info-race-comments-top-horse"><span class="place-name"></span> <span class="speed-distance"></span></td>
							</tr>
							<tr class="comment-row2" data-sticky-template="horse-info-race-comments-row-2">
								<td></td>
								<td></td>
								<td colspan="4" class="start-comment-cell">
									<div class="start-comment-container">
								    	<div class="comment"></div>
										<a class="add-start-comment-button sprite button-edit"></a>
									</div>
									<div class="user-start-comment-container">
										<div class="user-start-comment"></div>
										<a class="edit-start-comment-button sprite button-edit"></a>
									</div>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="buy-analysis">
						<div class="spelvarde"><img src="/images/spelvarde_logo_white.png" width="130" height="22px"></div>
						<a class="buy-button">
							<span class="sprite shopping-cart"></span>
							<span>%buy-analysis-title%</span>
						</a>
					</div>

					<div class="error-fetching-analysis">
						<div class="title">%error-fetching-analysis-title%</div>
						<div class="message">%error-fetching-analysis-message%</div>
					</div>

					<div class="analysis-wrapper">
						<table class="analysis-changes-conclusion">
							<thead>
							<tr>
								<th class="changes">%analysis-th-changes%</th>
								<th class="conclusion">%analysis-th-conclusion%</th>
								<th class="filler"></th>
							</tr>
							</thead>
							<tbody>
								<tr>
									<td class="changes"><div class="content"></div></td>
									<td class="conclusion"><div class="content"></div></td>
									<td class="filler"></td>
								</tr>
							</tbody>
						</table>

						<div class="analysis-statistics">
							<h4 class="analysis-statistics-header"></h4>
							<div class="analysis-statistics-body"></div>
						</div>

						<div class="analysis-headtohead">
							<h4 class="analysis-headtohead-header"></h4>
							<table class="race-history analysis-headtohead" data-sticky-template="headtohead">
								<colgroup>
									<col class="analysis-headtohead-col--placement">
									<col class="analysis-headtohead-col--horse">
									<col class="analysis-headtohead-col--driver">
									<col class="analysis-headtohead-col--dist">
									<col class="analysis-headtohead-col--time">
									<col class="analysis-headtohead-col--shoes">
									<col class="analysis-headtohead-col--odds">
								</colgroup>
								<thead>
									<tr>
										<th colspan="7">
											<div class="analysis-headtohead-table-header">
												<div class="analysis-headtohead-table-header-text">%headtohead-info%</div>
												<a class="analysis-headtohead-table-header-link">
													<span class="sprite button-play-white"></span>
												</a>
											</div>
										</th>
									</tr>
									<tr>
										<th>%headtohead-th-placement%</th>
										<th>%headtohead-th-horse%</th>
										<th>%headtohead-th-driver%</th>
										<th>%headtohead-th-dist%</th>
										<th>%headtohead-th-time%</th>
										<th>%headtohead-th-shoes%</th>
										<th>%headtohead-th-odds%</th>
									</tr>
								</thead>
								<tbody>
									<tr data-sticky-template="headtohead-row">
										<td class="placement"></td>
										<td class="horse"></td>
										<td class="driver"></td>
										<td class="dist"></td>
										<td class="time"></td>
										<td class="shoes"></td>
										<td class="odds"></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
`;

export default template;
